/** Documents granted by the legacy one-time entry plan (€89). */
export const ENTRY_PLAN_DOCUMENTS_QUOTA = 40;
/** Documents granted by the monthly Tipi plan (€39). */
export const MONTHLY_PLAN_DOCUMENTS_QUOTA = 5;
/** Documents granted by the first-month activation add-on (€100 list / €50 with intro coupon). */
export const FIRST_MONTH_ADDON_DOCUMENTS_QUOTA = 35;
/** Partner document grant for Repsol orgs (added on top of Stripe credits). */
export const REPSOL_DOCUMENTS_QUOTA = 100;
/** One billing month ≈ four weeks of weekly-note allotment. */
export const WEEKS_PER_BILLING_MONTH = 4;
/** €50 once coupon applied during the first 24h after lead creation (test + live share this id). */
export const INTRO_ACTIVATION_COUPON_ID = 'intro_24h_50eur';
export const ENTRY_PLAN_PRICE_ID_PROD = 'price_1TseaXGuvXPNQjWo0F60Vruu';
export const ENTRY_PLAN_PRICE_ID_TEST = 'price_1TsmHOGuvXPNQjWo6zxhVi9e';
export const MONTHLY_PLAN_PRICE_ID_PROD = 'price_1UAVdjGuvXPNQjWoEoLEQUO9';
export const MONTHLY_PLAN_PRICE_ID_TEST = 'price_1UFu0ZGuvXPNQjWoUU7hCn1r';
/** Current activation add-on (€100). First invoice list total with monthly plan = €139. */
export const FIRST_MONTH_ADDON_PRICE_ID_PROD = 'price_1UKbAlGuvXPNQjWoeG5lfUaE';
export const FIRST_MONTH_ADDON_PRICE_ID_TEST = 'price_1UKbSSGuvXPNQjWoirSNapLk';
/** Legacy €50 activation add-on — keep mapped for historical invoices. */
export const LEGACY_FIRST_MONTH_ADDON_PRICE_ID_PROD = 'price_1UDS4gGuvXPNQjWoQXdLlU5F';
export const LEGACY_FIRST_MONTH_ADDON_PRICE_ID_TEST = 'price_1UFu0ZGuvXPNQjWo4yE9XQDK';
/**
 * Legacy subscription tiers: N albaranes/semana.
 * Documents per paid monthly invoice = N × {@link WEEKS_PER_BILLING_MONTH}.
 */
export const LEGACY_WEEKLY_NOTES_PRICE_IDS = {
    TEN: {
        weeklyNotes: 10,
        prod: 'price_1RlRV3GuvXPNQjWoY9MjVYxF',
        test: 'price_1SIPWi2f7PcY44TCQ2W7AqHk',
    },
    TWENTY: {
        weeklyNotes: 20,
        prod: 'price_1RBAR1GuvXPNQjWoPm72lyz9',
        test: 'price_1SIPXq2f7PcY44TCrApkhJvg',
    },
    THIRTY: {
        weeklyNotes: 30,
        prod: 'price_1RshqlGuvXPNQjWo4PWY1AWT',
        test: 'price_1SIRXx2f7PcY44TCaEsXrsBg',
    },
    FORTY: {
        weeklyNotes: 40,
        prod: 'price_1RJCvsGuvXPNQjWoIrY3QUyO',
        test: 'price_1SIRcD2f7PcY44TCLbY7Rwgv',
    },
    FIFTY: {
        weeklyNotes: 50,
        prod: 'price_1Roi2YGuvXPNQjWofp4yPDfz',
        test: 'price_1SIRca2f7PcY44TCwHZn8wXV',
    },
};
/**
 * One-time document packs under Stripe product prod_SavP51Mva9ShU0 (live)
 * / prod_VJVxzTnWBwt74A (test): Compra de albaranes Tipi.
 */
export const DOCUMENT_PACK_PRICE_IDS = {
    TEN: {
        documents: 10,
        prod: 'price_1RfjYzGuvXPNQjWooz4MfOED',
        test: 'price_1UIsvPGuvXPNQjWoWaouWHrY',
    },
    FIFTY_FIVE: {
        documents: 55,
        prod: 'price_1U6VdFGuvXPNQjWoh4LTmrPd',
        test: 'price_1UIsvQGuvXPNQjWoafxW6Hcw',
    },
    ONE_HUNDRED_TWENTY: {
        documents: 120,
        prod: 'price_1U6Ve2GuvXPNQjWowAVsvU0D',
        test: 'price_1UIsvRGuvXPNQjWomGY8Hb9N',
    },
    TWO_HUNDRED_FIFTY: {
        documents: 250,
        prod: 'price_1U6VeiGuvXPNQjWo551N5dY0',
        test: 'price_1UIsvRGuvXPNQjWoh9HB7aTU',
    },
};
const buildPriceIdToDocumentsMap = () => {
    const map = new Map();
    map.set(ENTRY_PLAN_PRICE_ID_PROD, ENTRY_PLAN_DOCUMENTS_QUOTA);
    map.set(ENTRY_PLAN_PRICE_ID_TEST, ENTRY_PLAN_DOCUMENTS_QUOTA);
    map.set(MONTHLY_PLAN_PRICE_ID_PROD, MONTHLY_PLAN_DOCUMENTS_QUOTA);
    map.set(MONTHLY_PLAN_PRICE_ID_TEST, MONTHLY_PLAN_DOCUMENTS_QUOTA);
    map.set(FIRST_MONTH_ADDON_PRICE_ID_PROD, FIRST_MONTH_ADDON_DOCUMENTS_QUOTA);
    map.set(FIRST_MONTH_ADDON_PRICE_ID_TEST, FIRST_MONTH_ADDON_DOCUMENTS_QUOTA);
    map.set(LEGACY_FIRST_MONTH_ADDON_PRICE_ID_PROD, FIRST_MONTH_ADDON_DOCUMENTS_QUOTA);
    map.set(LEGACY_FIRST_MONTH_ADDON_PRICE_ID_TEST, FIRST_MONTH_ADDON_DOCUMENTS_QUOTA);
    for (const tier of Object.values(LEGACY_WEEKLY_NOTES_PRICE_IDS)) {
        const documents = tier.weeklyNotes * WEEKS_PER_BILLING_MONTH;
        map.set(tier.prod, documents);
        map.set(tier.test, documents);
    }
    for (const pack of Object.values(DOCUMENT_PACK_PRICE_IDS)) {
        map.set(pack.prod, pack.documents);
        map.set(pack.test, pack.documents);
    }
    return map;
};
const PRICE_ID_TO_DOCUMENTS = buildPriceIdToDocumentsMap();
/**
 * Documents granted by one unit of the given Stripe price.
 * Returns null when the price is not in the Tipi document-quota catalog.
 */
export const getDocumentsGrantedForStripePriceId = (priceId) => {
    const documents = PRICE_ID_TO_DOCUMENTS.get(priceId);
    return documents === undefined ? null : documents;
};
const MONTHLY_PLAN_PRICE_IDS = new Set([MONTHLY_PLAN_PRICE_ID_PROD, MONTHLY_PLAN_PRICE_ID_TEST]);
const FIRST_MONTH_ADDON_PRICE_IDS = new Set([
    FIRST_MONTH_ADDON_PRICE_ID_PROD,
    FIRST_MONTH_ADDON_PRICE_ID_TEST,
    LEGACY_FIRST_MONTH_ADDON_PRICE_ID_PROD,
    LEGACY_FIRST_MONTH_ADDON_PRICE_ID_TEST,
]);
export const isMonthlyPlanPriceId = (priceId) => MONTHLY_PLAN_PRICE_IDS.has(priceId);
export const isFirstMonthAddonPriceId = (priceId) => FIRST_MONTH_ADDON_PRICE_IDS.has(priceId);
export const listKnownDocumentQuotaPriceIds = () => [...PRICE_ID_TO_DOCUMENTS.keys()];
/**
 * Sums document credits from invoice line inputs using the Tipi price catalog.
 * Unknown prices contribute 0 and are listed in `unmappedLines`.
 */
export const aggregateDocumentQuotaCredits = (lines) => {
    const credits = [];
    const unmappedLines = [];
    let stripeSum = 0;
    for (const line of lines) {
        const quantity = Number.isFinite(line.quantity) && line.quantity > 0 ? Math.trunc(line.quantity) : 1;
        const documentsPerUnit = getDocumentsGrantedForStripePriceId(line.priceId);
        if (documentsPerUnit == null) {
            unmappedLines.push({
                invoiceId: line.invoiceId,
                priceId: line.priceId,
                quantity,
                paidAt: line.paidAt,
            });
            continue;
        }
        const documents = documentsPerUnit * quantity;
        stripeSum += documents;
        credits.push({
            invoiceId: line.invoiceId,
            priceId: line.priceId,
            quantity,
            documents,
            paidAt: line.paidAt,
        });
    }
    return { stripeSum, credits, unmappedLines };
};
//# sourceMappingURL=DocumentQuotaPriceCatalog.js.map